import { create } from 'zustand';

import { colorScheme, ColorSchemeType } from '@/modules/colorScheme';

const useStore = create<{
  theme: ColorSchemeType;
  setTheme: (theme: ColorSchemeType) => void;
}>((set) => ({
  theme: colorScheme.getTheme(),
  setTheme: (theme) => set({ theme }),
}));

export const useColorScheme = () => {
  const theme = useStore((store) => store.theme);
  const setTheme = useStore((store) => store.setTheme);

  return {
    theme,
    setTheme,
  };
};
